export const elementClicked = (
  webElement,
  actionOutcome,
  outboundUrl,
  correlationId,
  alternateType
) => {
  if (typeof tagular === 'undefined') {
    return
  }

  let elementType =
    alternateType || 'redventures.usertracking.v3.ElementClicked'

  webElement = {
    location: webElement.location,
    position: webElement.position,
    elementType: webElement.elementType,
    text: webElement.text,
    htmlId: webElement.htmlId,
    name: webElement.name
  }

  if (!webElement.name) {
    delete webElement.name
  }

  // eslint-disable-next-line no-undef
  tagular('beam', 'ElementClicked', {
    '@type': elementType,
    webElement,
    actionOutcome: actionOutcome,
    ...(outboundUrl && { outboundUrl }),
    correlationId: correlationId
  })
}

export const elementViewed = webElement => {
  if (typeof tagular === 'undefined') {
    return
  }

  // eslint-disable-next-line no-undef
  tagular('beam', 'ElementViewed', {
    '@type': 'redventures.usertracking.v3.ElementViewed',
    webElement: {
      location: webElement.location,
      position: webElement.position,
      elementType: webElement.elementType,
      text: webElement.text,
      htmlId: webElement.htmlId
    }
  })
}

export default {
  elementClicked,
  elementViewed
}
